import {ref} from 'vue';
import {defineStore} from 'pinia';

export const useLoadingStore = defineStore('loading', () => {
  const isOpened = ref(false);

  const close = () => {
    isOpened.value = false;
  };

  const show = () => {
    isOpened.value = true;
  };

  return {
    isOpened, show, close,
  };
});
